module.exports = __webpack_public_path__ + "static/media/bake.f6d11852.mp3";